<template>
	<form v-if="settings" @submit.prevent="saveSettings">
		<div class="gh-layout">
			<aside class="gh-intro">
				<h2 class="gh-intro__title">Salesforce</h2>
				<p class="gh-intro__desc">
					Connected app credentials and OAuth tokens for the Salesforce integration.
				</p>
			</aside>

			<section class="gh-accounts">
				<div class="ada-card">
					<div class="gh-section">
						<div class="gh-section__title">Connected App</div>
						<div class="gh-field">
							<label>Consumer Key</label>
							<input type="text" class="form-control" v-model="settings.consumerKey" />
						</div>
						<div class="gh-field">
							<label>Consumer Secret</label>
							<input type="text" class="form-control" v-model="settings.consumerSecret" />
						</div>
						<div class="gh-field">
							<label>Callback URL</label>
							<input type="text" class="form-control" v-model="settings.callbackUrl" />
						</div>
						<div class="gh-field">
							<label>Login URL</label>
							<input type="text" class="form-control" v-model="settings.loginUrl" />
						</div>
					</div>
					<div class="gh-section">
						<div class="gh-section__title">Credentials &amp; Tokens</div>
						<div class="gh-field">
							<label>Username</label>
							<input type="text" class="form-control" v-model="settings.username" />
						</div>
						<div class="gh-field">
							<label>Password</label>
							<input type="text" class="form-control" v-model="settings.password" />
						</div>
						<div class="gh-field">
							<label>Code</label>
							<input type="text" class="form-control" v-model="settings.code" />
						</div>
						<div class="gh-field">
							<label>Access Token</label>
							<input type="textarea" class="form-control" v-model="settings.accessToken" />
						</div>
						<div class="gh-field">
							<label>Refresh Token</label>
							<input type="textarea" class="form-control" v-model="settings.refreshToken" />
						</div>
					</div>
				</div>
			</section>
		</div>

		<hr class="gh-divider" />

		<div class="gh-save-row">
			<button class="gh-save-btn" type="submit">
				<i class="fas fa-save"></i>
				Save changes
			</button>
		</div>
	</form>
</template>

<script>
import restApi from '../../api/index.js'
import { handleErrors } from '../../actions/helpers'
export default {
	name: 'SalesforceSettings',
	data() {
		return {
			name: 'SalesforceSettings',
			type: 'settings',
			settings: {
				consumerKey: '',
				consumerSecret: '',
				callbackUrl: '',
				loginUrl: '',
				code: '',
				accessToken: '',
				refreshToken: '',
				username: '',
				password: '',
			},
		}
	},
	created() {
		this.getSettings()
	},
	methods: {
		getSettings() {
			restApi
				.get('/settings', { params: { name: this.name, type: this.type } })
				.then(({ data }) => {
					if (data) {
						this.settings = JSON.parse(data.data)
					}
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
		saveSettings() {
			restApi
				.post('/settings', {
					name: this.name,
					type: this.type,
					data: JSON.stringify(this.settings),
				})
				.then(({ data }) => {
					data.data = JSON.parse(data.data)
					this.settings = data.data
					this.$swal.fire({
						icon: 'success',
						title: 'Settings successfully saved!',
						timer: 4000,
					})
				})
				.catch(error => {
					this.$swal.fire({
						icon: 'error',
						title: handleErrors(error, ''),
						timer: 6000,
					})
				})
		},
	},
}
</script>
